import React, { useState } from 'react';
import './ClaimOfferModal.css';
import { BACKEND_URL } from '../../services/Helper';
import { toast } from 'react-toastify';

const ClaimOfferModal = ({ open, onClose, offer }) => {
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [claimedData, setClaimedData] = useState(null);
  const [copied, setCopied] = useState(false);

  if (!open || !offer) return null;

  const hasBonusDiscount =
    offer.percentageWithFeedback &&
    offer.percentageWithFeedback > offer.percentage;

  const claim = async (withFeedback) => {
    if (withFeedback && feedback.trim().length < 6) {
      toast.error('Please write at least 6 characters of feedback');
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('nearbeusertoken');
      const res = await fetch(`${BACKEND_URL}/nearbe/coupon/claim`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          offerId: offer._id,
          feedbackText: withFeedback ? feedback : '',
        }),
      });
      const data = await res.json();
      if (res.ok || res.status === 409) {
        setClaimedData(data);
        if (data.alreadyClaimed) {
          toast.info('You already claimed this offer — showing your existing code');
        }
      } else {
        toast.error(data.message || 'Failed to claim offer');
      }
    } catch {
      toast.error('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const copyCode = () => {
    navigator.clipboard.writeText(claimedData.couponCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleClose = () => {
    setFeedback('');
    setClaimedData(null);
    setCopied(false);
    onClose();
  };

  return (
    <div className="claim-overlay" onClick={handleClose}>
      <div className="claim-modal" onClick={(e) => e.stopPropagation()}>
        <button className="claim-close-btn" onClick={handleClose}>✕</button>

        {claimedData ? (
          <div className="coupon-success">
            <div className="coupon-success-icon">🎉</div>
            <h2 className="coupon-success-title">
              {claimedData.alreadyClaimed ? 'Already Claimed' : 'Offer Claimed!'}
            </h2>
            <p className="coupon-shop-name">{claimedData.shopName}</p>
            <p className="coupon-offer-title">{claimedData.offerTitle}</p>

            <div className="coupon-code-box">
              <div className="coupon-code-label">Your Coupon Code</div>
              <div className="coupon-code-value">{claimedData.couponCode}</div>
              <button className="coupon-copy-btn" onClick={copyCode}>
                {copied ? '✓ Copied!' : '📋 Copy'}
              </button>
            </div>

            <div className="coupon-discount-pill">{claimedData.discountApplied}% OFF</div>

            <p className="coupon-expiry">
              ⏰ Valid till:{' '}
              {new Date(claimedData.expiresAt).toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short',
              })}
            </p>
            <p className="coupon-instruction">
              Show this code to the shop owner to redeem your discount
            </p>
          </div>
        ) : (
          <div className="claim-form">
            <div className="claim-header">
              <h2>🎁 Claim This Offer</h2>
              <p className="claim-offer-name">{offer.title}</p>
              <p className="claim-shop-name">🏪 {offer?.postedBy?.shopName}</p>
            </div>

            <div className={`claim-options ${!hasBonusDiscount ? 'claim-options-single' : ''}`}>
              {/* Option A: instant claim */}
              <div className="claim-option-card">
                <div className="claim-option-pct">{offer.percentage}%</div>
                <div className="claim-option-pct-label">OFF</div>
                <p className="claim-option-desc">Instant claim — no feedback needed</p>
                <button
                  className="claim-btn claim-btn-instant"
                  onClick={() => claim(false)}
                  disabled={loading}
                >
                  {loading ? '...' : 'Claim Now'}
                </button>
              </div>

              {hasBonusDiscount && (
                <>
                  <div className="claim-divider"><span>OR get more</span></div>

                  {/* Option B: feedback for higher discount */}
                  <div className="claim-option-card claim-option-bonus">
                    <div className="claim-option-bonus-badge">⭐ BONUS</div>
                    <div className="claim-option-pct bonus-pct">
                      {offer.percentageWithFeedback}%
                    </div>
                    <div className="claim-option-pct-label">OFF</div>
                    <p className="claim-option-desc">
                      Share your experience for a bigger discount
                    </p>
                    <textarea
                      className="claim-feedback-input"
                      placeholder="Write your feedback about this shop (min. 6 chars)..."
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                      rows={3}
                    />
                    <button
                      className="claim-btn claim-btn-feedback"
                      onClick={() => claim(true)}
                      disabled={loading || feedback.trim().length < 6}
                    >
                      {loading ? '...' : `Get ${offer.percentageWithFeedback}% OFF`}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClaimOfferModal;
